import { Component, OnInit, ElementRef, ViewChild, TemplateRef, Inject, Output, EventEmitter, inject, OnDestroy, signal } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { ShareMapComponent } from '../share-map.component'
import { TranslateService, LangChangeEvent, TranslationChangeEvent, TranslateModule } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { TraceService } from '../../../services/trace.service';
import { PermalinkService } from '../../../services/permalink.service';
import { TraceRouteHistory } from '../../../models/trace-route-history';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { QRCodeComponent } from 'angularx-qrcode';
import { BackEventService } from '@tt-lib/services/back-event.service';

@Component({
  selector: 'share-map-dialog',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    TranslateModule,
    QRCodeComponent
],
  templateUrl: './share-map-dialog.component.html',
  standalone: true
})

export class ShareMapDialogComponent implements OnInit, OnDestroy {
  @ViewChild('template', { static: true }) template: any;
  private subscriptions: Subscription = new Subscription();

  @Output()
  public traceSavedEvt: EventEmitter<string> = new EventEmitter();

  savingInProgress = signal(false);
  savingFailed = signal(false);
  savingErrorMessage: string;
  public data= inject<ShareMapComponent>(MAT_DIALOG_DATA);
 
   constructor(
    public clipboard: Clipboard,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ShareMapDialogComponent>,
   
    private _traceService: TraceService,
    private _permalinkService: PermalinkService,
    private backEventService: BackEventService
  ) {
  }

  ngOnInit(): void {
    if (this._traceService.hasTraceRouteOrWaypointOnMap()) {
      //if a server token is still in the url (not local data), it means nothing has changed, the user didn't edit it
      let oldServerToken = this._traceService.getPermalinkParam();
      oldServerToken = oldServerToken && !TraceRouteHistory.isLocalStorageDataReference(oldServerToken) ? oldServerToken : null;
      if (!oldServerToken && !this._traceService.hasJustBeenSavedToExternalStorage()) {
       // console.log('init save')
        this.saveTrace();
      } else {
        this.traceSavedEvt.emit(oldServerToken);
      }
    }

    this.backEventService.registerOpenedWindow({windowName: 'ShareMapDialogComponent', isAutoCloseableWindow: true});
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /**
   * Saves the traces on the Download Portal 
   * Updates the hash of the last saved object to avoid saving the same data successively
   * by comparing the last hash with the hash of the candidate object 
   */
  saveTrace(): void {
    this.savingInProgress.set(true);
    this._traceService.saveTraceRouteDataToExternalStorage().subscribe({
      next: (uniqueIdentifier: string) => {
        this._traceService.updateLastSavedObjectHash();
        this.savingInProgress.set(false);
        console.log('emitting ', uniqueIdentifier)
        this.traceSavedEvt.emit(uniqueIdentifier);
      },
      error: (error) => {
        this.savingInProgress.set(false);
        this.savingFailed.set(true);
        this.savingErrorMessage = this.translate.instant(
          'general.http-errors.' + error
        );
      }
    });

  }
  /**
   * Copy the content of the field to the clipboard and shows a snackbar with a message
   */
  copyToClipboard(inputElement: any) {
    inputElement.setSelectionRange(0, 999);
    this.clipboard.copy(inputElement.value) ? this.showSnackBar('copied') : this.showSnackBar('copied-failed');
  }

  /**
   * Displays a message in a snackbar
   */
  private showSnackBar(type) {
    this.subscriptions.add(
      this.translate.get('share.' + type).subscribe((translation: string) => {
        this.snackBar.open(translation, 'ok', {
          duration: 2500,
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
      })
    );
  }
}